import React, { Component } from "react";
import FooterContactInfoNew from "./FooterContactInfoNew";
import axios from "axios";

export class Footer extends Component {
  state = {
    service_menu: [],
    footer_content: '',
    cms: ''
  };

  async servicemenusLoad() {
    try {
      let url = `${process.env.REACT_APP_API_URI}/serviceSection`;
      const response = await axios.get(url);
      this.setState({ service_menu: response?.data ?? [] });
    } catch (err) {
      console.error('Service menu load error in Footer:', err);
    }
  }

  async footerContentLoad() {
    try {
      let url = `${process.env.REACT_APP_API_URI}/footer-content`;
      const response = await axios.get(url);
      this.setState({ footer_content: response?.data ?? '' });
    } catch (err) {
      console.error('Footer content load error:', err);
    }
  }

  async cmsLoad() {
    try {
      let url = `${process.env.REACT_APP_API_URI}/cms`;
      const response = await axios.get(url);
      this.setState({ cms: response?.data?.data ?? '' });
    } catch (err) {
      console.error('CMS load error in Footer:', err);
    }
  }

  componentDidMount() {
    this.servicemenusLoad();
    this.footerContentLoad();
    this.cmsLoad();
  }

  render() {
    const { service_menu, footer_content, cms } = this.state;
    const currentYear = new Date().getFullYear();

    return (
      <footer className="footer widget-footer modern-footer bg-theme-DarkColor text-theme-WhiteColor clearfix">
        <div className="second-footer">
          <div className="container">
            <div className="row footer-main-row">
              {/* Col 1: Brand & About (4 cols) */}
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 widget-area footer-col">
                <div className="widget widget_text footer-widget-brand clearfix">
                  <div className="footer-logo">
                    <a href={process.env.PUBLIC_URL + '/'}>
                      <div className="footer-logo-badge">
                        <img
                          id="footer-logo-img"
                          className="img-fluid"
                          src="/images/logo-company.png"
                          alt={process.env.REACT_APP_NAME || "Euro Talent Hub"}
                        />
                      </div>
                    </a>
                  </div>
                  <p className="footer-brand-desc">
                    {footer_content.description ||
                      "Euro Talent Hub is a premier recruitment and talent solutions company connecting exceptional professionals with leading employers across Europe."}
                  </p>
                  
                  <div className="footer-social-bar">
                    {cms.footer_facebook_link && (
                      <a
                        href={cms.footer_facebook_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-btn"
                        aria-label="Facebook"
                      >
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                    )}
                    {cms.footer_instagram_link && (
                      <a
                        href={cms.footer_instagram_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-btn"
                        aria-label="Instagram"
                      >
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    )}
                    {cms.footer_youtube_link && (
                      <a
                        href={cms.footer_youtube_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-btn"
                        aria-label="LinkedIn"
                      >
                        <i className="fa-brands fa-linkedin-in"></i>
                      </a>
                    )}
                  </div>
                </div>
              </div>

              {/* Col 2: Useful Links (2 cols) */}
              <div className="col-xs-6 col-sm-6 col-md-3 col-lg-2 widget-area footer-col">
                <div className="widget widget-recent-post clearfix">
                  <h3 className="widget-title">Useful Links</h3>
                  <ul className="footer-clean-links">
                    <li>
                      <a href={process.env.PUBLIC_URL + '/'}>
                        <i className="fa-solid fa-chevron-right link-arrow"></i>
                        <span>Home</span>
                      </a>
                    </li>
                    <li>
                      <a href={process.env.PUBLIC_URL + '/about_us'}>
                        <i className="fa-solid fa-chevron-right link-arrow"></i>
                        <span>About Us</span>
                      </a>
                    </li>
                    <li>
                      <a href={process.env.PUBLIC_URL + '/gallery'}>
                        <i className="fa-solid fa-chevron-right link-arrow"></i>
                        <span>Gallery</span>
                      </a>
                    </li>
                    <li>
                      <a href={process.env.PUBLIC_URL + '/contact_01'}>
                        <i className="fa-solid fa-chevron-right link-arrow"></i>
                        <span>Contact Us</span>
                      </a>
                    </li>
                  </ul>

                  <div className="footer-complaint-wrapper">
                    <a
                      href="https://www.livroreclamacoes.pt/Inicio/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer-complaint-badge"
                    >
                      <i className="fa-solid fa-book-bookmark"></i>
                      <span>Livro de Reclamações</span>
                    </a>
                  </div>
                </div>
              </div>

              {/* Col 3: Quick Links / Services (2 cols) */}
              <div className="col-xs-6 col-sm-6 col-md-3 col-lg-2 widget-area footer-col">
                <div className="widget widget-recent-post clearfix">
                  <h3 className="widget-title">Quick Links</h3>
                  <ul className="footer-clean-links">
                    {service_menu && service_menu.length > 0 ? (
                      service_menu.slice(0, 5).map((v) => (
                        <li key={v.id}>
                          <a href={process.env.PUBLIC_URL + '/services/' + v.id}>
                            <i className="fa-solid fa-chevron-right link-arrow"></i>
                            <span>{v.title}</span>
                          </a>
                        </li>
                      ))
                    ) : (
                      <>
                        <li>
                          <a href={process.env.PUBLIC_URL + '/services'}>
                            <i className="fa-solid fa-chevron-right link-arrow"></i>
                            <span>Services</span>
                          </a>
                        </li>
                        <li>
                          <a href={process.env.PUBLIC_URL + '/StaffRequisition'}>
                            <i className="fa-solid fa-chevron-right link-arrow"></i>
                            <span>Staff Requisition</span>
                          </a>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>

              {/* Col 4: Quick Contact (4 cols) */}
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 widget-area footer-col">
                <FooterContactInfoNew />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom copyright & legal links bar */}
        <div className="bottom-footer-text">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7 col-md-12 text-center text-lg-start mb-2 mb-lg-0">
                <span className="copyright">
                  © {currentYear}{" "}
                  <a href={process.env.PUBLIC_URL + "/"}>
                    {process.env.REACT_APP_NAME || "Euro Talent Hub"}
                  </a>
                  . All rights reserved.
                </span>
              </div>
              <div className="col-lg-5 col-md-12 text-center text-lg-end">
                <ul className="footer-legal-nav">
                  <li>
                    <a href={process.env.PUBLIC_URL + "/"}>Privacy Policy</a>
                  </li>
                  <li className="bullet-sep">•</li>
                  <li>
                    <a href={process.env.PUBLIC_URL + "/"}>Terms & Conditions</a>
                  </li>
                  <li className="bullet-sep">•</li>
                  <li>
                    <a href={process.env.PUBLIC_URL + "/contact_01"}>Support</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
